/// <amd-module name="Feed/IvyPromote/Redux/IvyPromote/IvyPromoteSaga" />
import { SagaIterator } from "redux-saga";
import { effects } from "redux/redux-saga.compat";
import { ActionWithPayload } from "redux/Utils/ActionHelper";

import { IVssPageContext } from "VSS/Platform/Context";

import { IIvyRestClient } from "Feed/Common/Protocols/Ivy/RestClient/Ivy";
import { FeedHubActions } from "Feed/Core/Redux/FeedHub";
import { getSelectedUxParentFeed } from "Feed/Core/Redux/FeedHub/FeedHubSelectors";
import { IPackageVersion } from "Feed/Core/Types";
import { IvyPromoteActions, IvyPromoteActionTypes } from "Feed/IvyPromote/Redux/IvyPromote/IvyPromoteActions";

export default function* rootSaga(): SagaIterator {
    yield effects.takeEvery(IvyPromoteActionTypes.SavePackageStatus, savePackagePromoteStatus);
    yield effects.takeEvery(IvyPromoteActionTypes.GetPackageStatus, getPackagePromoteStatus);
    yield effects.call(loadStatusList);
}

export function* loadStatusList(): SagaIterator {
    try {
        const pageContext: IVssPageContext = (yield effects.getContext("pageContext")) as any;
        const ivyClient = pageContext.getRestClient<IIvyRestClient>("IIvyRestClient");
        const feed = (yield effects.select(getSelectedUxParentFeed)) as any;
        if (feed) {
            const statusList = (yield effects.call([ivyClient, ivyClient.promotionStatusList], feed.id)) as any;
            yield effects.put(IvyPromoteActions.statusListLoaded(statusList.map(s => s.name)));
        }
    } catch (e) {
        yield effects.put(IvyPromoteActions.apiCallFailed("Loading status list failed: " + e.message));
    }
}

export function* getPackagePromoteStatus(
    action: ActionWithPayload<IvyPromoteActionTypes.GetPackageStatus, IPackageVersion>
): SagaIterator {
    try {
        const pageContext: IVssPageContext = (yield effects.getContext("pageContext")) as any;
        const ivyClient = pageContext.getRestClient<IIvyRestClient>("IIvyRestClient");
        const feed = (yield effects.select(getSelectedUxParentFeed)) as any;

        if (feed) {
            const promotionStatus = (yield effects.call(
                [ivyClient, ivyClient.packagePromotionStatus],
                feed.id,
                action.payload.packageSummary.name,
                action.payload.packageVersion.version
            )) as any;
            yield effects.put(IvyPromoteActions.statusLoaded(promotionStatus.name));
        }
    } catch (e) {
        yield effects.put(IvyPromoteActions.apiCallFailed("Loading package status failed: " + e.message));
    }
}

export function* savePackagePromoteStatus(
    action: ActionWithPayload<
        IvyPromoteActionTypes.SavePackageStatus,
        { packageObject: IPackageVersion; setStatus: string }
    >
): SagaIterator {
    try {
        const pageContext: IVssPageContext = (yield effects.getContext("pageContext")) as any;
        const ivyClient = pageContext.getRestClient<IIvyRestClient>("IIvyRestClient");
        const feed = (yield effects.select(getSelectedUxParentFeed)) as any;
        if (feed) {
            yield effects.put(IvyPromoteActions.saveStarted());
            yield effects.call(
                [ivyClient, ivyClient.packagePromote],
                feed.id,
                action.payload.setStatus,
                action.payload.packageObject.packageSummary.name,
                action.payload.packageObject.packageVersion.version
            );
            yield effects.put(IvyPromoteActions.saveCompleted());
            yield effects.put(FeedHubActions.hideIvyPromote());
        }
    } catch (e) {
        yield effects.put(IvyPromoteActions.apiCallFailed("Saving package status failed: " + e.message));
    }
}
